import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import styled from 'styled-components';
const Button = styled.button `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: currentColor;
  height: 36px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 36px;

  &[data-active='true'] {
    fill: ${cssVar('accentColor')};
    stroke: red;

    
  }
`;
const Text = styled.span `
  ${srOnly}
`;
const Icon = styled.span `
  height: 17px;
  width: 17px;

  @media ${from(Device.Tablet)} {
    height: 22px;
    width: 22px;
  }

  path {
    fill: none;
    stroke: currentColor;
  }

  ${Button}[data-active='true'] & {
    path {
      fill: ${cssVar('accentColor')};
    }

    .theme-hta & {
      path {
        fill: ${brand.htaRebrand.greenAlt};
      }
    }
  }
`;
const Tooltip = styled.div `
  ${fonts.sourceSansPro.regular}
  font-size: 14px;
  position: absolute;
  top: 100%;
  right: 1px;
  background-color: ${brand.black};
  color: ${brand.white};
  display: none;
  width: 150px;
  padding: 5px 10px;
  box-shadow: 0 0 10px 0px rgba(0,0,0,0.27);
  z-index: 1;
  
  &:after {
    bottom: 100%;
    right: 12px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(black, 0);
    border-bottom-color: ${brand.black};
    border-width: 5px;
    margin-left: -5px;
  }

  [data-show-tooltip='true'] & {
    display: block;
  }
`;
export default {
    Button,
    Icon,
    Text,
    Tooltip,
};
